// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"

export default class FeatureCarouselController extends AdvancedController {

  static targets = [
    // TODO: use or remove
    // "exampleTarget",
    "navItem",
    "contentItem",
  ];

  static values = {
    index: Number,
    activeIndex: Number
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  }

  connect() {
    super.connect(...arguments)
    this.addActiveItem();
  }

  setActiveItem(e) {
    this.activeIndexValue = e.params.index;
    this.removeActiveItem();
    this.addActiveItem();
  }


  // removes active class from all nav items and content items
  removeActiveItem() {
    this.navItemTargets.forEach((navItem, index) => {
      if (index !== this.activeIndexValue) {
        navItem.classList.remove('-active');
      }
    });

    this.contentItemTargets.forEach((contentItem, index) => {
      if (index !== this.activeIndexValue) {
        contentItem.classList.remove('-active');
      }
    });
  }

  // adds active class to the active nav item and content item
  addActiveItem() {
    this.navItemTargets.forEach((navItem, index) => {
      if (index === this.activeIndexValue) {
        navItem.classList.add('-active');
      }
    });

    this.contentItemTargets.forEach((contentItem, index) => {
      if (index === this.activeIndexValue) {
        contentItem.classList.add('-active');
      }
    });
  }


}
